<app-section #parentSection
             class="installment-section"
             *ngIf="sectionVisible"
             [key]="key"
             [formConfig]="formConfig"
             [formGroup]="formGroup"
             [sectionRef]="section"
             [dropdown]="false"
             [title]="title">

  <ng-template #section>

    <app-radio-with-message *ngIf="isFieldTypeRadio(installmentConfig.PREMIUM_ID)"
            [bean]="bean"
            [errorsMap]="formFactoryService.errorsMap"
            [control]="formGroup.controls[installmentConfig.PREMIUM_ID]"
            [fieldConfig]="formFactoryService.fieldConfig(installmentConfig.PREMIUM_ID, formConfig)"
            (changeEvent)="onFieldChange($event)"
            [context]="formConfig.formKey"
            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
    </app-radio-with-message>

    <app-radio-checkbox-tile *ngIf="isFieldTypeRadioCheckboxTile(installmentConfig.PREMIUM_ID)"
                             #radioCheckboxTileComponent
                             [content]="radioCheckboxTileContent"
                             [contentData]="installmentTilesData"
                            [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[installmentConfig.PREMIUM_ID]"
                            [fieldConfig]="formFactoryService.fieldConfig(installmentConfig.PREMIUM_ID, formConfig)"
                            (changeEvent)="onFieldChange($event)"
                            [context]="formConfig.formKey"
                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
    </app-radio-checkbox-tile>

  </ng-template>

</app-section>

<ng-template #radioCheckboxTileContent let-data="data">
  <div class="installment">
    <div class="installment__label">
      <div class="installment__label__name">
        {{ data.label | translate }}
      </div>
      <div *ngIf="data.firstInstallmentAmount"
           class="installment__label__first-installment">
        <span class="installment__label__first-installment__label">
          {{ 'INSTALLMENT_SECTION.INSTALLMENTS.firstInstallment' | translate }}
        </span>
        <app-custom-price [price]="data.firstInstallmentAmount"></app-custom-price>
      </div>
    </div>

    <div class="installment__amount">
      <app-custom-price [price]="data.premiumAmount"></app-custom-price>
    </div>
  </div>
</ng-template>
